export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8952.1aa45ad8.jpg";